import API from "@irati/utils/services/API"
import endpoints from "../endpoints"
import {selfSignUpSettingsPutErrorHandler} from "./errors/selfSignUpErrorHandler"

API.registerErrorHandlers([selfSignUpSettingsPutErrorHandler])

/**
 * @todo: This service does not implement proper error codes so the errors cannot be classified
 *        For now we are surpressing all sentry errors as it is spamming for valid use cases.
 */

export const handleInvalidCode = (err) => {
  // This service pre-dates our standard error code format. Should remove once it is updated.
  if (err.response.data.error === "PBERR008x16") {
    throw new Error("errors.selfSignup.invalidCode")
  }
  throw err
}

export const getSelfSignupByID = (id, config = {}) => {
  API.sentryIgnoreAllErrors(config)

  return API.get(endpoints.selfSignup(id), config).then((res) => res.data)
}

export const getSelfSignupByTenant = (tenant, config = {}) => {
  API.sentryIgnoreAllErrors(config)
  return API.get(endpoints.selfSignupForTenant(tenant.uuid), config).then((res) => res.data)
}

export const getSelfSignupByTenantUnAuth = (tenant, config = {}) => {
  API.sentryIgnoreAllErrors(config)

  return API.get(`${endpoints.selfSignupForTenant(tenant.uuid)}/public`, config).then((res) => res.data)
}

export const createSelfSignup = (params, config = {}) => {
  API.sentryIgnoreAllErrors(config)

  return API.post(endpoints.selfSignups(), params, config)
    .then((res) => getSelfSignupByID(res.data.uuid))
    .catch(handleInvalidCode)
}

export const updateSelfSignUp = (id, params, config = {}) => {
  API.sentryIgnoreAllErrors(config)

  return API.put(endpoints.selfSignup(id), params, params.Etag, config)
    .then(() => getSelfSignupByID(id))
    .catch(handleInvalidCode)
}

export const sendCreateUserRequest = (id, secret, user, config = {}) => {
  API.sentryIgnoreAllErrors(config)
  const params = {secret, user}

  return API.post(`${endpoints.selfSignup(id)}/user`, params, config).catch(handleInvalidCode)
}

export const createOrUpdateSelfSignUp = (params, id = null) => {
  return id ? service.updateSelfSignUp(id, params) : service.createSelfSignup(params)
}

const service = {
  getSelfSignupByID,
  getSelfSignupByTenant,
  getSelfSignupByTenantUnAuth,
  createSelfSignup,
  updateSelfSignUp,
  sendCreateUserRequest,
  createOrUpdateSelfSignUp
}

export default service
